import React from "react";
import { useTranslation } from "react-i18next";
import { RiTableFill, RiTableLine, RiGridFill, RiGridLine } from "react-icons/ri";

function ControlsHeader({
  query,
  setQuery,
  typeView,
  setTypeView,
  effView,
  setEffView,
  statusView,
  setStatusView,
  viewMode,
  setViewMode,
  showToggle = true,
  searchPlaceholderKey = "controlManagement.searchPlaceholder",
}) {
  const { t } = useTranslation();
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 mt-2 mb-4 shadow-sm">
      <div className="flex flex-wrap items-center gap-2">

        {/* SEARCH */}
        <div className="relative flex-1 min-w-[260px]">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t(searchPlaceholderKey)}
            className="
            w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2
            outline-none border-none
            focus:outline-none focus:ring-0 focus:border-none
            active:outline-none active:ring-0 active:border-none
          "
          />
          <svg
            className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
            viewBox="0 0 24 24" fill="none"
          >
            <path
              d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        {/* TYPE FILTER */}
        <div className="relative">
          <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
            <path
              d="M3 5h18l-7 8v4l-4 2v-6L3 5z"
              stroke="currentColor"
              strokeWidth="1.5"
            />
          </svg>
          <select
            value={typeView}
            onChange={(e) => setTypeView(e.target.value)}
            className="
    appearance-none
    bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2
    outline-none border-none
    focus:outline-none focus:ring-0 focus:border-none
  "
          >
            {[
              { value: "All", labelKey: "all" },
              { value: "Preventive", labelKey: "preventive" },
              { value: "Detective", labelKey: "detective" },
              { value: "Mitigative", labelKey: "mitigative" },
            ].map(({ value, labelKey }) => (
              <option key={value} value={value}>
                {t(`controlManagement.filters.${labelKey}`)}
              </option>
            ))}
          </select>
          <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
          </svg>
        </div>

        {/* EFFECTIVENESS FILTER */}
        <div className="relative">
          <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
            <path d="M12 4a8 8 0 100 16 8 8 0 000-16z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M12 12l4-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <select
            value={effView}
            onChange={(e) => setEffView(e.target.value)}
            className="
    appearance-none
    bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2
    outline-none border-none
    focus:outline-none focus:ring-0 focus:border-none
  "
          >
            {[
              { value: "All", labelKey: "all" },
              { value: "High", labelKey: "high" },
              { value: "Medium", labelKey: "medium" },
              { value: "Low", labelKey: "low" },
            ].map(({ value, labelKey }) => (
              <option key={value} value={value}>
                {t(`controlManagement.filters.${labelKey}`)}
              </option>
            ))}
          </select>
          <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
          </svg>
        </div>

        {/* STATUS FILTER */}
        <div className="relative">
          <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
            <path d="M5 12h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <select
            value={statusView}
            onChange={(e) => setStatusView(e.target.value)}
            className="
    appearance-none
    bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2
    outline-none border-none
    focus:outline-none focus:ring-0 focus:border-none
  "
          >
            {[
              { value: "All", labelKey: "all" },
              { value: "Open", labelKey: "open" },
              { value: "In Progress", labelKey: "inProgress" },
              { value: "Closed", labelKey: "closed" },
            ].map(({ value, labelKey }) => (
              <option key={value} value={value}>
                {t(`controlManagement.filters.${labelKey}`)}
              </option>
            ))}
          </select>
          <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
          </svg>
        </div>

        {/* GRID / TABLE TOGGLE — LEFT EXACTLY AS BEFORE */}
        {showToggle && viewMode !== undefined && setViewMode && (
          <div className="flex items-center gap-0 ml-auto border border-gray-300 rounded-lg overflow-hidden">
            <button
              onClick={() => setViewMode("table")}
              className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition ${viewMode === "table"
                  ? "bg-[#0E0E0E] text-white"
                  : "bg-white text-gray-600 hover:bg-gray-50"
                }`}
            >
              {viewMode === "table" ? <RiTableFill size={16} /> : <RiTableLine size={16} />}
            </button>

            <button
              onClick={() => setViewMode("grid")}
              className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition border-l border-gray-300 ${viewMode === "grid"
                  ? "bg-[#0E0E0E] text-white"
                  : "bg-white text-gray-600 hover:bg-gray-50"
                }`}
            >
              {viewMode === "grid" ? <RiGridFill size={16} /> : <RiGridLine size={16} />}
            </button>
          </div>
        )}

      </div>
    </div>
  );



}

export default ControlsHeader;


